import { gql, useQuery, TypedDocumentNode } from '@apollo/client'
import React from 'react'
import { WebSite } from 'schema-dts'

import { getCacheableContext } from '@emico/apollo'

import JsonLd from './JsonLd'
import {
  StoreConfigSchemaOrgQuery,
  StoreConfigSchemaOrgQueryVariables,
} from './WebsiteWithSearchAction.generated'

const query = gql`
  query StoreConfigSchemaOrg {
    storeConfig {
      storeName
      baseUrl
    }
  }
` as TypedDocumentNode<
  StoreConfigSchemaOrgQuery,
  StoreConfigSchemaOrgQueryVariables
>

type Props = Partial<WebSite> & {
  queryUrlFragment?: string
}

const WebsiteWithSearchAction = ({ queryUrlFragment, ...others }: Props) => {
  const { data } = useQuery(query, {
    context: getCacheableContext(),
  })
  if (!data?.storeConfig || !data?.storeConfig.baseUrl) {
    return null
  }

  return (
    <JsonLd<WebSite>
      item={{
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        url: data.storeConfig.baseUrl,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${data.storeConfig.baseUrl}${
            queryUrlFragment ?? 'search?query='
          }{query}`,
        },
        ...others,
      }}
    />
  )
}

export default WebsiteWithSearchAction
